/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Gbp_Oauth_Not_ConfiguredInputs */

const cs_integrations_gbp_oauth_not_configured = /** @type {(inputs: Integrations_Gbp_Oauth_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlášení přes Google není na tomto serveru nastavené. Požádejte správce.`)
};

const en_integrations_gbp_oauth_not_configured = /** @type {(inputs: Integrations_Gbp_Oauth_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google sign-in is not configured on this server. Ask your administrator.`)
};

/**
* | output |
* | --- |
* | "Google sign-in is not configured on this server. Ask your administrator." |
*
* @param {Integrations_Gbp_Oauth_Not_ConfiguredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_gbp_oauth_not_configured = /** @type {((inputs?: Integrations_Gbp_Oauth_Not_ConfiguredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Gbp_Oauth_Not_ConfiguredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_gbp_oauth_not_configured(inputs)
	return cs_integrations_gbp_oauth_not_configured(inputs)
});